import { render } from "./UiSwitch.vue?vue&type=template&id=149be9d4&scoped=true&ts=true"
import script from "./UiSwitch.vue?vue&type=script&lang=ts"
export * from "./UiSwitch.vue?vue&type=script&lang=ts"

import "./UiSwitch.vue?vue&type=style&index=0&id=149be9d4&scoped=true&lang=css"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149be9d4"]])

export default __exports__